<template>
  <div v-show="show" id="footer">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-6 wow zoomIn animate__animated animate__backInLeft boxwenzi"
           style="align-items: center">
        <img src="../assets/img/footer/1.png" style="width: 398px;height: 47px">
        <p class="left-wen">
          <span>团结</span>
          <span>诚信</span>
          <span>创新</span>
          <span>共进</span>
        </p>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 wow zoomIn animate__animated animate__backInLeft boxwenzi"
           style=" text-align: left;">
        <p class="title">联系我们</p>
        <p class="address_tel_fax">
          <span style="font-weight: bold">地址</span>
          <div style="display: flex;gap: 10px;flex-wrap: wrap">
            <div v-for="(item,index) in info.address" :key="index" class="address_tel_fax"
                 style="display: flex;justify-content: space-between;">
              {{ item.name }}：{{ item.value }}
            </div>
          </div>
        </p>
        <p class="address_tel_fax">
          <span style="font-weight: bold">销售热线</span>
          <div style="display: flex;gap: 10px;flex-wrap: wrap">
            <div v-for="(item,index) in info.salePhone" :key="index" class="address_tel_fax"
                 style="display: flex;justify-content: space-between;">
              {{ item.name }}：{{ item.value }}
            </div>
          </div>

        </p>
        <p class="address_tel_fax">
          <span style="font-weight: bold">技术支持</span>
          <div style="display: flex;gap: 10px;flex-wrap: wrap">
            <div v-for="(item,index) in info.technologyPhone" :key="index" class="address_tel_fax"
                 style="display: flex;justify-content: space-between;">
              {{ item.name }}：{{ item.value }}
            </div>
          </div>

        </p>
        <p class="address_tel_fax">
          <span>邮   箱：{{ info.email }}</span>
        </p>
      </div>
    </div>
    <div class="bottom-box ">
      <p class="wow zoomIn animate__animated animate__slideInUp">
        渝ICP备2024019687号
      </p>
    </div>
  </div>
</template>
<script>
import {getInformationTable} from "@/api/api";

export default {
  name: "Footer",
  data() {
    return {
      info: {},
      show: false
    };
  },
  mounted() {
    getInformationTable(1).then(res => {
      this.info = res.data.data;
      this.info.salePhone = JSON.parse(this.info.salePhone)
      this.info.technologyPhone = JSON.parse(this.info.technologyPhone)
      this.info.address = JSON.parse(this.info.address)
      console.log(this.info);
    })
    setTimeout(() => {
      this.show = true
    }, 1000)
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}

.boxwenzi {
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 300px;
}

.left-wen {
  width: 398px;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  color: rgba(155, 155, 155, 1);

  display: flex;
  justify-content: center;
  gap: 16px;
}

.bottom-box {
  width: 100%;
  height: 109px;
  opacity: 1;
  background: rgba(43, 47, 54, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0px;
  color: rgba(155, 155, 155, 1);
  text-align: center;
  vertical-align: top;
}

.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}

.title {
  font-size: 16px;
  font-weight: bold;
  //margin-bottom: 20px;
}

.address_tel_fax {
  color: #d3d3d3;
  font-size: 16px;
  color: rgba(155, 155, 155, 1);
  cursor: pointer;
}

.address_tel_fax:hover {
  color: #ffffff !important;
}

.email_wx {
  color: #d3d3d3;
  font-size: 16px;
}

.copy {
  color: #d3d3d3;
  font-size: 16px;
  margin: 50px 0 10px;
}

@media screen and (max-width: 997px) {
  .title {
    font-size: 16px;
  }

  .boxwenzi {
    height: 150px;
    padding: 40px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {

    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue